import React, { useState } from "react";
import { signIn } from "src/api";
import { renderSuccessMessage, setToStorage } from "src/assets/functions";
import { Logo } from "src/assets/images";
import { loginperson } from "src/assets/images";
import { useProtectedRoutesContext } from "src/context/ProtectedRoutes";
import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { ErrorMessage, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import Modal from "src/components/modal/Modal";
import ResetEmail from "src/components/modal/ResetEmail";
import { BsEye, BsEyeSlash } from "react-icons/bs";



const Login = () => {
    const { setUser, setToken } = useProtectedRoutesContext();
    const [visible, setVisible] = useState(false);
    const navigate = useNavigate();
    const [isAddResetEmailModalOpen, setIsAddResetEmailModalOpen] = useState(false);

    const signInSchema = yup.object().shape({
        email: yup
            .string()
            .email("Please provide a valid email")
            .required("Please provide a valid email"),
        password: yup
            .string()
            .required("Please provide password")
    });
    const initialValues = {
        email: "",
        password: "",
    };

    const { mutate, isLoading } = useMutation(signIn, {
        onSuccess: (data) => {
            renderSuccessMessage(data?.message);
            setUser(data?.user);
            setToken(data?.token);
            setToStorage("user", data?.user);
            setToStorage("token", data?.token);
            navigate(`/`);
        },

    });

    return (
        <div className="flex min-h-screen">
            {/* Left Section - col-lg-4 */}
            <div className="w-full lg:w-1/3 flex flex-col  items-center p-10">
                <Formik
                    initialValues={initialValues}
                    validationSchema={signInSchema}
                    onSubmit={(values) => mutate(values)}
                >
                    {({
                        values,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            {/* Logo */}
                            <a href="/"><img src={Logo} alt="Logo" className="w-[120px] mb-[35px]" /></a>

                            {/* Welcome Text */}
                            <h2 className="text-2xl font-semibold text-gray-800 mb-[35px]">Welcome to Fatix Wax</h2>

                            {/* Email Input */}
                            <input
                                type="email"
                                placeholder="Email"
                                name="email"
                                value={values.email}
                                onChange={handleChange}
                                className="w-full border p-3 rounded-md mb-[35px] focus:outline-none focus:ring-2 focus:ring-green-500"
                            />
                            <ErrorMessage
                                name="email"
                                component="div"
                                className="text-red-500  error-message"
                            />

                            {/* Password Input */}
                            <div className="has-pwd-icon">
                                <input
                                    type={visible ? "text" : "password"}
                                    placeholder="Password"
                                    name="password"
                                    onChange={handleChange}
                                    value={values.password}
                                    className="w-full border p-3 rounded-md mb-[35px] focus:outline-none focus:ring-2 focus:ring-green-500"
                                />
                                {visible ? (
                                    <BsEye
                                        className="view-pwd1"
                                        size={20}
                                        onClick={() =>
                                            setVisible(
                                                (prevState) =>
                                                    !prevState
                                            )
                                        }
                                    />
                                ) : (
                                    <BsEyeSlash
                                        className="view-pwd1"
                                        size={20}
                                        onClick={() =>
                                            setVisible(
                                                (prevState) =>
                                                    !prevState
                                            )
                                        }
                                    />
                                )}
                                <ErrorMessage
                                    name="password"
                                    component="div"
                                    className="text-red-500  error-message"
                                />
                            </div>

                            {/* Login Button */}
                            <button className="w-full text-white p-3 rounded-md transition login-up-btn mt-[25px]">
                                Login
                            </button>
                            <div className="reset-password" onClick={() => {
                                setIsAddResetEmailModalOpen(true)
                            }} >Reset Password</div>
                            {/* Sign Up Link */}
                            <p className="mt-4 text-gray-600">
                                Don't have an account? <a href="/register" className="text-green-600 font-semibold">Sign Up</a>
                            </p>
                        </form>
                    )}
                </Formik>
                <Modal isOpen={isAddResetEmailModalOpen} setIsOpen={setIsAddResetEmailModalOpen} title="Reset Email" size="sm">
                    <ResetEmail setIsOpen={setIsAddResetEmailModalOpen} />
                </Modal>
            </div>



            {/* Right Section - col-lg-8 */}
            {/* Right Section - col-lg-8 */}
            <div className="hidden lg:flex w-2/3 out-of-pocket-bg p-[50px] relative">
                <img
                    src={loginperson}
                    alt="Login Illustration"
                    className="w-full h-full object-cover"
                />

                {/* Text Overlay */}
                <div className="absolute bottom-[120px] left-1/2 transform -translate-x-1/2 bg-white bg-opacity-20 backdrop-blur-md border border-white rounded-lg px-6 py-[30px] text-center shadow-lg">
                    <h2 className="text-lg font-semibold text-gray-900 welcome-sub-header">Bringing Bold Style to Life</h2>
                    <p className="text-sm text-gray-700 welcome-sub-header-sub">Fabrics That Inspire Your Creative Vision , More Than Just Fabric — A Story Behind Every Piece</p>
                </div>
            </div>

        </div>
    );
};

export default Login;
